import AccommodationPackageInclusionsList from 'components/AccommodationKit/AccommodationPackageInclusionsList'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import type { ComponentProps } from 'react'
import { useContext } from 'react'

type InheritedAccommodationPackageInclusionsListProps = Omit<ComponentProps<typeof AccommodationPackageInclusionsList>, 'duration'>

interface Props extends InheritedAccommodationPackageInclusionsListProps {
}

function OfferPagePackageInclusionsList({ title, ...rest }: Props) {
  const { offer, duration } = useContext(OfferPageStateContext)

  const isFlash = isFlashHotelOffer(offer)

  return <AccommodationPackageInclusionsList
    {...rest}
    duration={duration}
    title={!isFlash && title === 'bonus' ? 'bonus' : title}
  />
}

export default OfferPagePackageInclusionsList
